import { BookingCompressed, ResourceFloorDto } from '@jooxter/api';
import { IFloorPlanResource } from '@jooxter/floor-plan';
import { useCallback } from 'react';
import { useResourceTypeRepository } from '@jooxter/resource-types';

const DEFAULT_MAP_ICON_SIZE = 1;

export const useResourceFloorDTOToIFloorPlanResourceConverter = (
  resources: ResourceFloorDto[] = [],
  bookings: BookingCompressed[] = []
) => {
  const { repository } = useResourceTypeRepository();

  const convert = useCallback((): IFloorPlanResource[] => {
    if (!repository) {
      return [];
    }

    return resources.map((rc) => ({
      ...rc,
      resourceType: repository.findById(rc.resourceTypeId) ?? {
        mapIconSize: DEFAULT_MAP_ICON_SIZE,
        showMapIcon: false,
        allowOverlap: false,
      },
      bookings: bookings.filter((b) => b.resource.id === rc.id),
    }));
  }, [repository, resources, bookings]);

  return { convert };
};
